import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Stack, Typography, Divider, Button, styled } from "@mui/material";
import {
  GridToolbarExport,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SaveAltIcon from "@mui/icons-material/SaveAlt";

import { exportToExcelWithTabs } from "../../../helpers/exportToExcel";

export function MyExportButton({ page, name, rows, dataToExcel }) {
  const { t } = useTranslation("global");
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const onAdd = () => {
    page === "partner" && navigate("/addpartner");
    page === "companies" && navigate("/addCompanie");
    page === "startup" && navigate("/addStartup");
    page === "vehicle" && navigate("/addVehicle");
    page === "startupValoration" && navigate("/addStartupValoration");
    page === "opportunities" && navigate("/addOpportunities");
    page === "events" && navigate("/addEvent");
    page === "fundsAdmin" && navigate("/addFunds");
    page === "positionsAdmin" && navigate("/createRound");
    page === "distributionFundTable" &&
      navigate(
        `/addFundDistribution?fund=${searchParams.get("fund")}&hasVideo=${
          rows.length
        }`
      );
    page === "positionsViewList" &&
      navigate(
        `/addPosition?opportunity=${searchParams.get(
          "opportunity"
        )}&valuation=${searchParams.get(
          "valuation"
        )}&vehicle=${searchParams.get("vehicle")}`
      );
    page === "viewFundsAdmin" &&
      navigate(`/addContributions?fund=${searchParams.get("fund")}`);
    page === "opportunitiesReservation" &&
      navigate(
        `/addReservation?opportunity=${searchParams.get(
          "opportunity"
        )}&reservation=${rows.map((a) => a.individualId).toString()}`
      );
    page === "registeredEvent" &&
      navigate(
        `/addRegisteredEvent?event=${searchParams.get(
          "event"
        )}&name=${searchParams.get("name")}`
      );
  };

  return (
    <Stack>
      <GridToolbarContainer
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          gap: 3,
        }}
      >
        <Stack direction="row" justifyContent="center" alignItems="center">
          <Typography
            color="primary"
            component="h2"
            sx={{ typography: { md: "h6", xs: "subtitle1" } }}
          >
            {t(`tablestitles.${page}`)}
            {name && !users?.includes(name) && name !== "Admin" && name + ":"}
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="center" flexWrap="wrap" gap={3}>
          <Root>
            <GridToolbarColumnsButton
              color="secondary"
              variant="text"
              size="small"
            />
            <GridToolbarDensitySelector
              color="secondary"
              variant="text"
              size="small"
            />
            {page !== "positionsClub" &&
              page !== "divestmentClub" &&
              page !== "positionLP" &&
              page !== "networking" && (
                <GridToolbarExport
                  color="secondary"
                  variant="text"
                  size="small"
                  printOptions={{ disableToolbarButton: true }}
                />
              )}
            {page === "positionsClub" && (
              <Button
                onClick={() =>
                  exportToExcelWithTabs(dataToExcel, "inversiones_latentes")
                }
                color="secondary"
                startIcon={<SaveAltIcon />}
              >
                {t("toExcel.export")}
              </Button>
            )}
            {page === "divestmentClub" && (
              <Button
                onClick={() =>
                  exportToExcelWithTabs(
                    dataToExcel,
                    "inversiones_realizadas",
                    "Faraday Europa I, FCRE"
                  )
                }
                color="secondary"
                startIcon={<SaveAltIcon />}
              >
                {t("toExcel.export")}
              </Button>
            )}
            {page === "positionLP" && (
              <Button
                onClick={() =>
                  exportToExcelWithTabs(dataToExcel, "inversiones_LP")
                }
                color="secondary"
                startIcon={<SaveAltIcon />}
              >
                {t("toExcel.export")}
              </Button>
            )}
          </Root>
          {!users?.includes(name) && !notButton?.includes(page) && (
            <Button
              color="secondary"
              onClick={onAdd}
              variant="text"
              size="small"
              startIcon={<AddCircleIcon color="secondary" />}
            >
              {t("addpartner.addButton")}
            </Button>
          )}
        </Stack>
      </GridToolbarContainer>
      <Divider sx={{ marginTop: 2, marginBottom: 5 }} />
    </Stack>
  );
}

const users = ["LP", "Club", "Híbrido"];
const notButton = [
  "positions",
  "divestmentClub",
  "positionsClub",
  "positionLP",
  "noTitle",
  "networking"
];

const Root = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "block",
  },
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
